import axiosInstance from "../axiosInstance";

const CONTROLLER = "paymentTerms";

const get_payment_terms = async (search) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}?search=${search || ""}`
	);
	return response.data;
};

const get_payment_terms_page = async (search, state, page) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetPage?search=${
			search || ""
		}&state=${state}&pageNumber=${page}`
	);
	return response.data;
};

const get_payment_term_by_id = async (id) => {
	const response = await axiosInstance.get(`${CONTROLLER}/GetById/${id}`);
	return response.data;
};

const create_payment_term = async (activeIngredient) => {
	const response = await axiosInstance.post(`${CONTROLLER}`, activeIngredient);
	return response.data;
};

const update_payment_term = async (id, activeIngredient) => {
	const response = await axiosInstance.put(
		`${CONTROLLER}/${id}`,
		activeIngredient
	);
	return response.data;
};

const get_payment_terms_header_info = async (search) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetPaymentTermsHeader`
	);
	return response.data;
};

const update_payment_term_state = async (id, state) => {
	const response = await axiosInstance.put(
		`${CONTROLLER}/UpdatePaymentTermsState/${id}`,
		state
	);
	return response.data;
};

export {
	get_payment_terms,
	get_payment_terms_page,
	create_payment_term,
	get_payment_term_by_id,
	update_payment_term,
	get_payment_terms_header_info,
	update_payment_term_state,
};
